import { EyeFilled, EyeInvisibleFilled } from '@ant-design/icons';
import { Switch } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { ColumnBaseProps } from '../types';

const VisibilityColumn: React.FC<ColumnBaseProps> = ({ record }) => {
  return (
    <Switch
      checkedChildren={<EyeFilled />}
      unCheckedChildren={<EyeInvisibleFilled />}
      checked={record.formField.supervisorVisibility}
      onClick={record.formField.supervisorVisibilityToggleModel.toggle}
    />
  );
};

export default observer(VisibilityColumn);
